import React from "react";

const WebHostingHomes = () => {
  const topics = [
    { name: "Getting Started", icon: "🚀" },
    { name: "Hospitality", icon: "⭐" },
    { name: "Pricing & Payouts", icon: "💰" },
    { name: "Safety & Policies", icon: "🛡️" },
    { name: "Performance", icon: "📊" },
    { name: "Tools", icon: "🧰" },
  ];

  const sections = [
    {
      title: "Get started as a host",
      items: [
        "Exploring your new hosting tools",
        "Helping your listing stand out",
        "Managing your calendar",
        "Introducing Hosting Services",
      ],
    },
    {
      title: "Deliver 5-star hospitality",
      items: [
        "Welcoming your first guests",
        "Preparing your space",
        "Refreshing your listing",
        "Using guest reviews to improve",
      ],
    },
    {
      title: "Your hosting tools",
      items: [
        "Reviewing your price",
        "Scheduling messages to save time",
        "Comparing similar listings",
        "Managing your prices",
      ],
    },
  ];

  return (
    <>
        <style>
          {`
            #main {
                margin-top:0;
                padding: 20px 0px;
            }
            .rc-hero {
                padding-top:0;
            }
            .resource-center {
                padding: 0;
            }
            .rc-search button {
                padding: 4px 10px;
            }
            .rc-cards {
                display: flex;
                overflow-x: auto;
                gap: 15px;
                padding-bottom: 10px;
                scroll-snap-type: x mandatory;
            }
            .rc-card {
                min-width: 220px;
                flex-shrink: 0;
                scroll-snap-align: start;
            }
            .rc-cards::-webkit-scrollbar {
                display: none;
            }
            .rc-section-header h3 {
                font-size: 18px;
            }
            .rc-showall {
                font-size: 16px;
            }
            .topic-card {
                width: calc(50% - 15px);
                flex: auto;
            }
          `}
        </style>
        <div className="resource-center">
            {/*<header className="rc-header">
                <h1>Resource Center</h1>
                <button className="rc-btn">Become a Host</button>
            </header>*/}

            <section className="rc-hero">
                <h2>How can we help?</h2>
                <p>
                Find articles, guides, and tools to help you succeed, from your first
                booking to your hundredth.
                </p>
                <div className="rc-search">
                <input type="text" placeholder="Search guides and articles" />
                <button>Search</button>
                </div>
            </section>

            <section className="rc-topics">
                <h3>Explore by topic</h3>
                <div className="topics-grid">
                {topics.map((topic, index) => (
                    <div key={index} className="topic-card">
                    <div className="topic-icon">{topic.icon}</div>
                    <p>{topic.name}</p>
                    </div>
                ))}
                </div>
            </section>

            {sections.map((section, idx) => (
                <Section key={idx} title={section.title} items={section.items} />
            ))}

            <section className="rc-discover">
                <div className="overlay">
                <h3>Discover the latest upgrades to help you host</h3>
                <button>Read more</button>
                </div>
            </section>
        </div>
    </>
  );
};

const Section = ({ title, items }) => (
  <section className="rc-section">
    <div className="rc-section-header">
      <h3>{title}</h3>
      <a href={'/resources/details/what-is-lorem-ipsum-'} className="rc-showall">Show all</a>
    </div>
    <div className="rc-cards">
      {items.map((item, index) => (
        <div key={index} className="rc-card">
          <img src="https://images.contentstack.io/v3/assets/bltb428ce5d46f8efd8/blt3ac2f5322ad65d29/609c45e57f38be03500fe7f1/PJM013418Q426-Seasonal_Africa-Day6-2-Host_ChiChi-01261_169crop.jpg" alt="" className="rc-card-img" />
          <p className="rc-card-txt">{item}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WebHostingHomes;
